import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PayeeHeaderComponent } from '../../../shared/payee-header/payee-header.component';
import { PayeeIconComponent } from '../../../shared/payee-icon/payee-icon.component';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-header-empty',
  templateUrl: './header-empty.component.html',
  styleUrls: ['./header-empty.component.scss'],
  imports: [PayeeHeaderComponent, PayeeIconComponent, NgTemplateOutlet],
})
export class HeaderEmptyComponent {
  @Input() payeeLink = environment.HELP_URL; // 'https://payee.tech';

  @ContentChild('logoTemplate') logoTemplateRef?: TemplateRef<unknown>;
  @ContentChild('buttonTemplate') buttonTemplateRef?: TemplateRef<unknown>;
}
